export default __webpack_public_path__ + "static/media/special-design.411cc0ae.png";